import styled, {css} from "styled-components"

import perks from "@irati/ui/images/logoPerks.png"
import celebration from "@irati/ui/images/logoCelebration.png"
import medical from "@irati/ui/images/logoMedical.png"
import wellness from "@irati/ui/images/logoWellness.svg"

import mobilePerks from "@irati/ui/images/logoMobilePerks.png"
import mobileRecognition from "@irati/ui/images/logoMobileRecognition.png"
import mobileMedical from "@irati/ui/images/logoMobileMedical.png"
import mobileWellness from "@irati/ui/images/logoMobileWellness.svg"

import admin from "@irati/ui/images/logoAdmin.png"
import perkboxAlt from "@irati/ui/images/logo-alt.svg"
import smallPerkoxLogo from "@irati/ui/images/logo-alt_small.svg"

import google from "@irati/ui/images/google.svg"
import okta from "@irati/ui/images/okta.svg"
import azure from "@irati/ui/images/azure.svg"
import workDay from "@irati/ui/images/workday.svg"
import bambooHr from "@irati/ui/images/bamboohr.svg"
import saml from "@irati/ui/images/saml.png"
import microsoft from "@irati/ui/images/microsoft.svg"
import bob from "@irati/ui/images/bob.png"

const logoCSS = css`
  height: 24px;
  width: auto;
`
const integrationsLogoCSS = css`
  height: 16px;
  width: auto;
`

const integrationsBigLogoCSS = css`
  height: 30px;
  width: auto;
`

interface PerkboxLogoProps {
  size?: number
}
export const PerkboxLogo = styled.img.attrs({
  src: perkboxAlt,
  alt: "Perkbox"
})<PerkboxLogoProps>`
  ${logoCSS}
  ${({size}) => size && `height: ${size}px;`}
`

export const SmallPerkboxLogo = styled.img.attrs({
  src: smallPerkoxLogo,
  alt: "Perkbox"
})<PerkboxLogoProps>`
  ${logoCSS}
  ${({size}) => size && `height: ${size}px;`}
`

export const AdminLogo = styled.img.attrs({
  src: admin,
  alt: "Admin logo"
})`
  ${logoCSS}
`

export const PerksLogo = styled.img.attrs({
  src: perks,
  alt: "Perks logo"
})`
  ${logoCSS}
`

export const CelebrationLogo = styled.img.attrs({
  src: celebration,
  alt: "Celebration logo"
})`
  ${logoCSS}
`

export const MedicalLogo = styled.img.attrs({
  src: medical,
  alt: "Medical logo"
})`
  ${logoCSS}
`

export const WellnessLogo = styled.img.attrs({
  src: wellness,
  alt: "Wellness logo"
})`
  ${logoCSS};
  height: 21px;
`

export const MobileWellnessLogo = styled.img.attrs({
  src: mobileWellness,
  alt: "Wellness logo"
})`
  ${logoCSS};
  height: 21px;
`

export const MobilePerksLogo = styled.img.attrs({
  src: mobilePerks,
  alt: "Perks logo"
})`
  ${logoCSS}
`

export const MobileRecognitionLogo = styled.img.attrs({
  src: mobileRecognition,
  alt: "Recognition logo"
})`
  ${logoCSS}
`

export const MobileMedicalLogo = styled.img.attrs({
  src: mobileMedical,
  alt: "Medical logo"
})`
  ${logoCSS}
`

export const GoogleLogo = styled.img.attrs({
  src: google,
  alt: "Google logo"
})`
  ${integrationsLogoCSS}
`

export const OktaLogo = styled.img.attrs({
  src: okta,
  alt: "Okta logo"
})`
  ${integrationsBigLogoCSS}
`

export const AzureLogo = styled.img.attrs({
  src: azure,
  alt: "Azure logo"
})`
  ${integrationsLogoCSS}
`

export const WorkDayLogo = styled.img.attrs({
  src: workDay,
  alt: "WorkDay logo"
})`
  ${integrationsLogoCSS}
`

export const BambooHrLogo = styled.img.attrs({
  src: bambooHr,
  alt: "BambooHr logo"
})`
  ${integrationsLogoCSS}
`

export const SamlLogo = styled.img.attrs({
  src: saml,
  alt: "Saml logo"
})`
  ${integrationsLogoCSS}
`

export const MicrosoftLogo = styled.img.attrs({
  src: microsoft,
  alt: "Microsoft logo"
})`
  ${integrationsLogoCSS}
`

export const BobLogo = styled.img.attrs({
  src: bob,
  alt: "Bob logo"
})`
  ${integrationsLogoCSS}
`

export const MicrosoftTeamsLogo = styled.img.attrs({
  alt: "Microsoft Teams Logo"
})`
  ${logoCSS}
`
